module.exports = __webpack_public_path__ + "static/img/Patient.cdccd8c2.jpg";